import { _ } from "../../../../core/polyglot/polyglot.js";
import AbstractAccountGroupRowTemplate from "./AbstractAccountGroupRowTemplate.js";
import AccountGroupRow from "../../reports/rows/AccountGroupRow.js";

/**
 * Row linked to a COA accoung group.
 * Stores additional rows for its dynamically generated children.
 */
export default class AccountGroupRowTemplate extends AbstractAccountGroupRowTemplate {
	addExcludedGroup(groupId) {
		this._excludedGroupsIds.push(groupId);
	}

	removeExcludedGroup(groupId) {
		this._excludedGroupsIds = this._excludedGroupsIds.filter(
			(id) => id !== groupId,
		);
	}

	setExcludedGroups(groupIds) {
		this._excludedGroupsIds = groupIds;
	}

	canHaveChildren() {
		return false;
	}

	isAccountGroupRowTemplate() {
		return true;
	}

	accept(visitor) {
		return visitor.visitAccountGroupRowTemplate(this);
	}

	_instanceClass() {
		return AccountGroupRow;
	}

	static getLabel() {
		return _("Chart Of Accounts group");
	}

	static getType() {
		return "AccountGroupRowTemplate";
	}
}
